var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPinkSpringWire = function SvgPinkSpringWire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2312,
    height: 533,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2291.48 431.621C2141.21-89.601 608.636 848.765 699.178 381.459c82.068-423.57 492.452-172.877 258.992-16.153-441.868 296.626-638.935 2.26-757.726-220.24C152.775 55.782 87.393 17.321 17.5 17.379",
    stroke: "#F05",
    strokeWidth: 33,
    strokeLinecap: "square"
  })));
};
export default SvgPinkSpringWire;